import { combineReducers } from 'redux';

import {
  getUserPermissionsListByUserRequest,
  getUserPermissionsListByUserSuccess,
  getUserPermissionsListByUserFail,
  clearUserPermissionsListByUser,
} from '../actions';
import { StateListUserPermissions, UserPermissionsAction } from '../types';
import { stripItems } from '../../../../utility/store';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof StateListUserPermissions> = Reducer<StateListUserPermissions, UserPermissionsAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getUserPermissionsListByUserRequest.type:
      return state ? stripItems(state) : null;

    case getUserPermissionsListByUserSuccess.type:
      return action.payload;

    case clearUserPermissionsListByUser.type:
      return null;
    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getUserPermissionsListByUserRequest.type:
      return true;

    case getUserPermissionsListByUserSuccess.type:
    case getUserPermissionsListByUserFail.type:
      return false;

    default:
      return state;
  }
};


export default combineReducers<StateListUserPermissions>({
  data,
  loading,
});
